<div class="gw-min-h-screen gw-flex gw-flex-col gw-bg-background-base">
  <div class="gw-flex gw-justify-end gw-p-medium">
    <app-language-selector></app-language-selector>
  </div>

  <div class="gw-flex gw-flex-1 gw-items-center gw-justify-center gw-p-medium">
    <div
      class="gw-w-full gw-max-w-[420px] gw-bg-background-elevation-2 gw-border gw-border-border-normal gw-rounded-2xl gw-shadow-lg gw-overflow-hidden gw-p-2x-large"
    >
      <h2 class="gw-text-lg gw-font-semibold gw-text-text-primary gw-mb-small">
        {{ 'features.passwordResetRequest.page.title' | translate }}
      </h2>
      <p class="gw-text-sm gw-text-text-secondary gw-mb-2x-large">
        {{ 'features.passwordResetRequest.page.description' | translate }}
      </p>

      <form
        [formGroup]="passwordReset"
        (ngSubmit)="onSubmit()"
        class="gw-flex gw-flex-col gw-gap-2x-large"
      >
        <gatewee-input-v2
          id="password-reset-request-email"
          type="email"
          [form]="passwordReset"
          controlName="email"
          [label]="
            'features.passwordResetRequest.form.labels.email' | translate
          "
          [placeholder]="
            'features.passwordResetRequest.form.placeholders.email' | translate
          "
          [required]="true"
        ></gatewee-input-v2>

        <div class="gw-flex gw-flex-col gw-items-center gw-gap-medium">
          <a
            routerLink="/login"
            class="gw-text-sm gw-font-medium gw-text-text-action hover:gw-underline"
          >
            {{ 'features.passwordResetRequest.form.needHelp' | translate }}
          </a>
          <gatewee-button
            variant="primary"
            [title]="
              'features.passwordResetRequest.form.submitButton' | translate
            "
            type="submit"
            class="gw-w-full"
            [disabled]="passwordReset.invalid"
          ></gatewee-button>
        </div>
      </form>
    </div>
  </div>

  <app-links></app-links>
</div>
